import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { P } from "../../../../AbstractElements";
import { Text } from "../../../../Constants/Constants";

const DropdownText = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle caret color="dark" className="text-white">{Text}</DropdownToggle>
        <DropdownMenu className="p-4 form-wrapper">
          <P>{"Some example text that's free-flowing within the dropdown menu."}</P>
          <P className="mb-0">{"And this is more example text."}</P>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default DropdownText;
